import { render } from "./DeleteBrandDialog.vue?vue&type=template&id=c07b11c0"
import script from "./DeleteBrandDialog.vue?vue&type=script&lang=js"
export * from "./DeleteBrandDialog.vue?vue&type=script&lang=js"

import "./DeleteBrandDialog.vue?vue&type=style&index=0&id=c07b11c0&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__